import ReactDOM from 'react-dom/client';
import {registerSW} from 'virtual:pwa-register';
import './site.scss';

import '@mantine/charts/styles.css';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/dropzone/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/spotlight/styles.css';
import 'mantine-react-table/styles.css';

import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

import 'src/utilities/extensions/arrayExtensions';
import 'src/utilities/extensions/stringExtensions';

import * as Sentry from '@sentry/react';
import {shouldIgnoreSentryEvent} from 'src/shared/utils/SentryEventFilter';
import {notifyServiceWorkerUpdate} from 'src/app/routing/versionService';
import App from './App';

const browserTracingIntegration = Sentry.browserTracingIntegration({
  tracePropagationTargets: [window.location.origin, import.meta.env.VITE_API!],
});
const replayIntegration = Sentry.replayIntegration({
  networkDetailAllowUrls: [window.location.origin, import.meta.env.VITE_API!],
  maskAllInputs: false,
  maskAllText: false,
});
Sentry.init({
  dsn: 'https://f62c5c7b0bbc22ae76ddf999604f4b80@o4505720317149184.ingest.sentry.io/4505720318328832',
  integrations: [browserTracingIntegration, replayIntegration],
  // Configure environment tag for analytical tracking
  environment: import.meta.env.VITE_ENV,
  // Performance Monitoring
  tracesSampleRate: Number(import.meta.env.VITE_SENTRY_TRACE_SAMPLE_RATE),
  // Session Replay
  replaysSessionSampleRate: Number(
    import.meta.env.VITE_SENTRY_REPLAY_SAMPLE_RATE
  ),
  replaysOnErrorSampleRate: Number(
    import.meta.env.VITE_SENTRY_REPLAY_ERROR_SAMPLE_RATE
  ),
  enabled: import.meta.env.VITE_SENTRY_ENABLED === 'true',
  enableTracing: import.meta.env.VITE_SENTRY_ENABLED === 'true',
  // Drop errors thrown from browser-extension code (stack frames outside our
  // bundle). Complements the message-based rules in SentryEventFilter.
  denyUrls: [
    /^chrome-extension:\/\//,
    /^moz-extension:\/\//,
    /^safari(-web)?-extension:\/\//,
  ],
  // Drop known-benign, non-actionable errors (see SentryEventFilter for the
  // configurable rule list) so they do not pollute error reports.
  beforeSend: (event, hint) =>
    shouldIgnoreSentryEvent(event, hint) ? null : event,
});

// TODO: Re-enabled React strict mode!!! This should be done after moving the data loading API calls out of useEffect hooks.
/*
  <React.StrictMode>
    <App />
  </React.StrictMode>
*/
ReactDOM.createRoot(document.getElementById('root')!).render(<App />);

const updateSW = registerSW({
  immediate: true,
  onNeedRefresh() {
    notifyServiceWorkerUpdate(() => updateSW(true));
  },
});
